module.exports = __webpack_public_path__ + "img/PT.1aa68d61.svg";